import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse } from 'interfaces/httpClient';
import { RetainerInfo, UploadFile } from '@/interfaces';

class ApplicationsService {
	constructor(private client: AxiosInstance) {}

	async getRetainerInfo(
		applicationId: number
	): Promise<HttpResponse<RetainerInfo>> {
		return this.client(`/application/${applicationId}/retainer-info`);
	}
	async postSignLawyer(
		applicationId: number,
		sign: string
		// actionRequiredId: number // not required by the endpoint
	): Promise<{ message: string }> {
		return this.client.post(
			`/action-required/${applicationId}/approve-and-send-retainer`,
			{ sign }
		);
	}
	async postSignUser(
		applicationId: number,
		sign: string,
		actionRequiredId: number
	): Promise<{ message: string }> {
		return this.client.post(`/action-required/sign-retainer`, {
			application_id: applicationId,
			sign,
			action_id: actionRequiredId,
		});
	}
	async postSignUploadUser(data: UploadFile): Promise<{ message: string }> {
		const formData = new FormData();
		data.doc && formData.append('doc', data.doc);
		data.applicationId &&
			formData.append('applicationId', String(data.applicationId));
		data.actionRequiredId &&
			formData.append('actionRequiredId', String(data.actionRequiredId));
		formData.append('sign', data.sign ?? '');
		data.fileName && formData.append('fileName', data.fileName);
		data.is_approved && formData.append('is_approved', data.is_approved);
		return this.client.post(`/action-required/upload-sign-retainer`, formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});
	}
}

export const applicationsService = new ApplicationsService(axiosClient);
